var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { itemId, listItemId, } from "../types";
export var updateSelection = function (selection, oldResult, newResult) {
    var numSelected = selection.length;
    if (newResult == null || numSelected === 0 || newResult === oldResult) {
        return selection;
    }
    var resultSet = new Set(newResult.map(function (t) { return t[itemId]; }));
    var newSelection = selection.filter(function (t) { return resultSet.has(t[itemId]); });
    return newSelection.length < numSelected ? newSelection : selection;
};
export var selectItem = function (item, selected, listData, placards, galleryItems, resultIdMatchesListId) {
    var _a, _b;
    var _c, _d, _e;
    if (selected.findIndex(function (s) { return s[listItemId] === item; }) >= 0) {
        return selected;
    }
    if (resultIdMatchesListId) {
        return __spreadArray(__spreadArray([], selected, true), [(_a = {}, _a[itemId] = item, _a[listItemId] = item, _a)], false);
    }
    var id = (_c = listData === null || listData === void 0 ? void 0 : listData.find(function (t) { return t[listItemId] === item; })) === null || _c === void 0 ? void 0 : _c[itemId];
    if (id == null) {
        id = (_d = placards === null || placards === void 0 ? void 0 : placards.find(function (t) { return t[listItemId] === item; })) === null || _d === void 0 ? void 0 : _d[itemId];
    }
    if (id == null) {
        id = (_e = galleryItems === null || galleryItems === void 0 ? void 0 : galleryItems.find(function (t) { return t[listItemId] === item; })) === null || _e === void 0 ? void 0 : _e[itemId];
    }
    if (id == null) {
        return selected;
    }
    return __spreadArray(__spreadArray([], selected, true), [(_b = {}, _b[itemId] = id, _b[listItemId] = item, _b)], false);
};
export var unselectItem = function (item, selected) {
    var index = selected.findIndex(function (s) { return s[listItemId] === item; });
    if (index < 0) {
        return selected;
    }
    return __spreadArray(__spreadArray([], selected.slice(0, index), true), selected.slice(index + 1), true);
};
export var selectAllItems = function (searchResult) {
    return (searchResult === null || searchResult === void 0 ? void 0 : searchResult.map(function (s) {
        var _a;
        return (_a = {}, _a[itemId] = s[itemId], _a[listItemId] = s[itemId], _a);
    })) || [];
};
//# sourceMappingURL=helpers.js.map